module.exports = __webpack_public_path__ + "static/media/user.6c40d57d.svg";